import {makeActionCreator} from '../../core-utilities/redux';
import {MAIN_MENU_PREFIX} from '../redux/state';

export const hideMenu = makeActionCreator(MAIN_MENU_PREFIX, 'hideMenu');

export const showMenu = makeActionCreator(MAIN_MENU_PREFIX, 'showMenu');

export const toggleMenu = makeActionCreator(MAIN_MENU_PREFIX, 'toggleMenu');



// WEBPACK FOOTER //
// ./src/js/app/actions/mainMenu.js